<template>
  <div class="text-center">
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>근무구분</v-list-item-title>
          <v-list-item-subtitle> {{ replaceGubun==='전일'?'종일':replaceGubun }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>휴일 근무일자</v-list-item-title>
          <v-list-item-subtitle> {{ workYmd }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>휴일 업무내용</v-list-item-title>
          <v-list-item-subtitle> {{ note }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>시업시간(휴일)</v-list-item-title>
          <v-list-item-subtitle> {{ reqTime }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>추가휴계(휴일)</v-list-item-title>
          <v-list-item-subtitle> {{ addRestTime }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>휴일근무시간</v-list-item-title>
          <v-list-item-subtitle> {{ reqHm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>평일대체근무기간</v-list-item-title>
          <v-list-item-subtitle> {{ replacePeriod }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>평일대체근무일자</v-list-item-title>
          <v-list-item-subtitle> {{ replaceYmd }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-show="replaceGubunShow">
          <v-list-item-title>시업시간(평일)</v-list-item-title>
          <v-list-item-subtitle> {{ replaceTime }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-show="replaceGubunShow">
          <v-list-item-title>추가휴계(평일)</v-list-item-title>
          <v-list-item-subtitle>
            {{ replaceAddRestTime }}
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-show="replaceGubunShow">
          <v-list-item-title>평일근무시간</v-list-item-title>
          <v-list-item-subtitle> {{ replaceHm }} </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- <hol-replace-cancel-sub-view :appInfoParam="appInfoParam" /> -->
  </div>
</template>
<script>
import {
  getHolReplaceDetail,
  getHolReplaceAppDetHoliChk,
} from '@/api/workStatus';
import { mapMutations, mapGetters } from 'vuex';
import dayjs from 'dayjs';
import ViewerBottomBtn from '@/components/application/buttons/ViewerBottomBtn.vue';
//import HolReplaceCancelSubView from '@/views/application/form/HolReplaceCancelSubView.vue';
import routerNames from '@/const/routerConstants';
import { getUiInfo } from '@/api/approvalCommon';

export default {
  data: () => ({
    replaceGubun: '',
    workYmd: '',
    note: '',
    reqTime: '',
    addRestTime: '',
    reqHm: '',
    replaceYmd: '',
    replacePeriod: '',
    replaceAddRestTime: '',
    replaceHm: '',
    cancelView: false,
    replaceTime: '',
    replaceGubunShow: false,
  }),
  props: {
    appInfoParam: Object,
  },
  computed: {
    ...mapGetters(['GET_SEQ_NO']),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
    async cancel() {
      /*
      this.$router.push({
        name: routerNames.HolReplaceCancelSubView,
        params: this.appInfoParam,
      });
      */

      this.$store.commit('SET_APPL_SEQ', this.appInfoParam.applSeq);
      /*
      const applParam = {
        applCd: '311',
      };

      await this.$store.dispatch('ELA/FETCH_MENU_ACTION', applParam);
      */
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'application_viewer');
      //this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
      this.$router.push({
        name: routerNames.HolReplaceCancelSubView,
        params: this.appInfoParam,
      });
    },
  },

  async created() {

    this.cancelView = this.appInfoParam.cancelView;
    let response = await getHolReplaceDetail(this.appInfoParam);

    this.replaceGubun =
      response.data.data.replaceGubun === 'H' ? '반일' : '전일';

    if (response.data.data.replaceGubun === 'H') {
      this.replaceGubunShow = true;
    } else {
      this.replaceGubunShow = false;
    }

    this.workYmd = response.data.data.workYmd;
    this.note = response.data.data.note;
    this.reqTime = response.data.data.reqTime;
    this.addRestTime = response.data.data.addRestTime;
    if (response.data.data.reqSHm === null) {
      response.data.data.reqSHm = '';
    }

    if (response.data.data.reqEHm === null) {
      response.data.data.reqEHm = '';
    }

    this.reqHm =
      response.data.data.reqSHm.slice(0, 2) +
      ':' +
      response.data.data.reqSHm.slice(2) +
      ' ~ ' +
      response.data.data.reqEHm.slice(0, 2) +
      ':' +
      response.data.data.reqEHm.slice(2);

    this.replaceYmd = dayjs(response.data.data.replaceYmd).format('YYYY-MM-DD');
    this.replaceAddRestTime = response.data.data.replaceAddRestTime;
    this.replaceTime = response.data.data.replaceTime;

    if (response.data.data.replaceSHm === null) {
      response.data.data.replaceSHm = '';
    }

    if (response.data.data.replaceEHm === null) {
      response.data.data.replaceEHm = '';
    }

    this.replaceHm =
      response.data.data.replaceSHm.slice(0, 2) +
      ':' +
      response.data.data.replaceSHm.slice(2) +
      ' ~ ' +
      response.data.data.replaceEHm.slice(0, 2) +
      ':' +
      response.data.data.replaceEHm.slice(2);

    const params = {
      gubun: 'W',
      workYmd: this.workYmd.replaceAll('-', ''),
    };

    // 날짜 체크
    response = await getHolReplaceAppDetHoliChk(params);
    console.dir(response);
    if (response.data.data !== null) {
      this.replacePeriod = response.data.data.startDate.substring(0, 4) + '-' + response.data.data.startDate.substring(4, 6) + '-' + response.data.data.startDate.substring(6, 8)
      + ' ~ ' + response.data.data.endDate.substring(0, 4) + '-' + response.data.data.endDate.substring(4, 6) + '-' + response.data.data.endDate.substring(6, 8);
    }

    response = await getUiInfo(this.appInfoParam);
    console.dir(response);

    if (response.data.data.fileYn === 'N') {
      this.$emit('showFileView', false);
    } else {
      this.$emit('showFileView', true);
    }

    this.OFF_APP_SPINNER();
  },

  components: { ViewerBottomBtn },
};
</script>
